// extracted by mini-css-extract-plugin
export default {"noDesktop":"no-desktop_noDesktop__LINv4","icon":"no-desktop_icon__sqB-r","opacity-transition":"no-desktop_opacity-transition__kMvZ+"};